import { Component, OnInit, Input } from '@angular/core';
import { SsLoaderService } from './ss-loader.service';

@Component({
  selector: 'ss-loader',
  template: `
  <div id="loading" class="loader" [ngStyle]="{'background': 'url(' + d_img + ') no-repeat center center','background-size':d_gif_size+'px', 'background-color':d_color}" *ngIf="showLoader"></div>
  `,
  styles: [`
  #loading {
    position: fixed;
    width: 100%;
    height: 100vh;
    margin:0px !important;
    // background:url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik02NCA5Ljc1QTU0LjI1IDU0LjI1IDAgMCAwIDkuNzUgNjRIMGE2NCA2NCAwIDAgMSAxMjggMGgtOS43NUE1NC4yNSA1NC4yNSAwIDAgMCA2NCA5Ljc1eiIgZmlsbD0iIzA4MmZmNSIgZmlsbC1vcGFjaXR5PSIxIi8+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgNjQgNjQiIHRvPSIzNjAgNjQgNjQiIGR1cj0iMTAwMG1zIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPjwvZz48L3N2Zz4=') no-repeat center center;
    // background-color: #0007;
    // background-size: 10%;
    background-position:center;
    z-index: 9999;
    cursor: progress;
  }
  body {
    margin:0px !important;
    }`
  ]
})
export class SsLoaderComponent implements OnInit {

  @Input() imageUrl: string;
  @Input() size: number;
  @Input() bgColor: any;
  showLoader: boolean;

  d_img = `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik02NCA5Ljc1QTU0LjI1IDU0LjI1IDAgMCAwIDkuNzUgNjRIMGE2NCA2NCAwIDAgMSAxMjggMGgtOS43NUE1NC4yNSA1NC4yNSAwIDAgMCA2NCA5Ljc1eiIgZmlsbD0iIzA4MmZmNSIgZmlsbC1vcGFjaXR5PSIxIi8+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgNjQgNjQiIHRvPSIzNjAgNjQgNjQiIGR1cj0iMTAwMG1zIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPjwvZz48L3N2Zz4=`;
  d_color = '#0007';
  d_gif_size = 100;

  constructor(private loaderService: SsLoaderService) { }
  visible: boolean;
  ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      if(this.imageUrl != undefined){
        this.d_img = this.imageUrl;
      }
      if(this.size != undefined){
        this.d_gif_size = this.size;
      }
      if(this.bgColor != undefined){
        this.d_color = this.bgColor;
      }
      this.showLoader = val;
    });
  }

}
